import { Observable, Subject } from 'rxjs';

import { Injectable } from '@angular/core';

import { SnCamera } from '@lib/api/entities';

@Injectable({
  providedIn: 'root',
})
export class CameraTableService {
  private _cameraUpdated$ = new Subject<SnCamera>();

  constructor() {}

  get cameraUpdated$(): Observable<SnCamera> {
    return this._cameraUpdated$.asObservable();
  }

  public onUpdated(camera: SnCamera): void {
    this._cameraUpdated$.next(camera);
  }
}
